import { useAppStore } from "@/hooks/useAppStore";
import { useTheme } from "../themes/ThemeProvider";
import { useTranslation } from "@/lib/translate";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Button } from "../ui/button";

export const ErrorOverlay = () => {
  const { resolvedTheme } = useTheme();
  const clientConfig = useAppStore((state) => state.clientConfig);
  const preferredLanguage = useAppStore((state) => state.preferredLanguage);
  const t = useTranslation(preferredLanguage);

  const logoSrc =
    resolvedTheme === "dark" && clientConfig?.config?.logoDark
      ? clientConfig.config.logoDark
      : clientConfig?.config?.logo;

  return (
    <div className="absolute top-0 left-0 bg-[#000000DD] h-[100dvh] w-full overflow-hidden">
      <div className="flex min-h-screen items-center justify-center p-4">
        <Card className="w-full max-w-sm rounded-4xl border-0">
          <CardHeader className="text-center">
            <CardTitle className="text-2xl uppercase tracking-[4px] text-chotto-gold items-center flex justify-center">
              <img src={logoSrc} width="230" alt="logo" />
            </CardTitle>
            <h1 className="text-lg mt-4">
              {t("Oops! An unexpected error occurred. Please try again later.")}
            </h1>
          </CardHeader>
          <CardContent className="space-y-4 mt-6 items-center justify-center flex flex-col">
            <Button
              onClick={() => {
                window.location.href = "/";
              }}
              className="px-12 py-6 text-lg rounded-3xl"
            >
              {t("Reload")}
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};
